import { render, staticRenderFns } from "./h8-table.vue?vue&type=template&id=0681e383&"
import script from "./h8-table.component.ts?vue&type=script&lang=ts&"
export * from "./h8-table.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/h8udm/release-builds/release-2.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0681e383')) {
      api.createRecord('0681e383', component.options)
    } else {
      api.reload('0681e383', component.options)
    }
    module.hot.accept("./h8-table.vue?vue&type=template&id=0681e383&", function () {
      api.rerender('0681e383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/h8-component/h8-table.vue"
export default component.exports